"use strict";
exports.__esModule = true;
exports.MessageCodec = exports.errorMessageCodec = exports.successMessageCodec = void 0;
var t = require("io-ts");
var JSONCodec_1 = require("./packages/codecs/JSONCodec");
var semverCodec = t.tuple([t.number, t.number, t.number]);
var messageTypeCodec = t.keyof({
    req: null,
    res: null,
    evt: null
});
exports.successMessageCodec = t.type({
    type: messageTypeCodec,
    name: t.string,
    id: t.string,
    version: semverCodec,
    payload: t.string,
    error: t["null"]
});
exports.errorMessageCodec = t.type({
    type: messageTypeCodec,
    name: t.string,
    id: t.string,
    version: semverCodec,
    payload: t.string,
    error: t.string
});
var messageCodec = t.union([exports.errorMessageCodec, exports.successMessageCodec]);
exports.MessageCodec = new JSONCodec_1.JSONCodec('MessageCodec', messageCodec);
//# sourceMappingURL=messageCodec.js.map